import PropTypes from "prop-types";
import { useEffect } from "react";
import { Provider } from "react-redux";
import store from "./store";
import PremierLandingPageLayout from "./containers/PremierLandingPageLayout/index";
import { setAssetsPath } from "./actions/Environment";
import {
  setContent,
  setContentError,
  setFirstName,
  setIncludeFreeTrials,
} from "./actions/PremierPageFrame";
import { fetchCountries } from "./actions/PremierSelectorOptions";
import {
  getFirstName,
  isAuthenticated,
  promptLogin,
} from "./utils/identityUtils";
import { trackPageEvent } from "./utils/trackPageEvent";

export default function App({ appConfig, contentStrings, assetsUrl }) {
  const getTrialParamFromUrl = () => {
    const url = new URL(window.location.href);
    const campaign = url.searchParams.get("campaign");
    return campaign === "freeTrial";
  };

  useEffect(() => {
    const context = window?.asos && window.asos.webContext;
    const webContext = {
      country: context.getBrowseCountry(),
      currency: context.getBrowseCurrency(),
      language: context.getBrowseLanguage(),
      storeId: context.getStoreId(),
    };
    const includeFreeTrials = getTrialParamFromUrl();

    const handleLoginForTrial = async () => {
      const loggedIn = await isAuthenticated();
      if (!loggedIn && includeFreeTrials) {
        await promptLogin();
      }
      const firstName = await getFirstName();
      store.dispatch(setFirstName(firstName));
    };
    handleLoginForTrial();

    store.dispatch(setAssetsPath(assetsUrl));
    if (!contentStrings) {
      store.dispatch(setContentError());
    } else {
      store.dispatch(setContent(contentStrings));
      store.dispatch(setIncludeFreeTrials(includeFreeTrials));
    }
    store.dispatch(
      fetchCountries(
        webContext.country,
        webContext.currency,
        webContext.storeId,
        webContext.language
      )
    );
  }, []);

  useEffect(() => {
    trackPageEvent();
  }, []);

  return (
    <Provider store={store}>
      <PremierLandingPageLayout appConfig={appConfig} />
    </Provider>
  );
}

App.propTypes = {
  appConfig: PropTypes.object,
  contentStrings: PropTypes.object.isRequired,
  assetsUrl: PropTypes.string.isRequired,
  includeFreeTrials: PropTypes.bool,
};

App.defaultProps = {
  appConfig: {},
  includeFreeTrials: false,
};
